import React, { useContext } from 'react'
import TodoContext from '../todoCtx/TdoCtx';
import "./students.css"

const Students = () => {

    const {dblListItems, setDblListItems, showDblList, setShowDblList, dblListItemsSepa, setDblListItemsSepa, compTodosMove1, showRecycleBin,setShowRecycleBin, showForm, setShowForm,formData, setFormData,students, studentClass,studentName} = useContext(TodoContext);

  return (
    <div className='studentsContainer'>
        
<ul>
        {students && students.map((student,index)=>(
      
        <li key={index} className="fullNameWrapper" > 
          
        
       <h4 className='fullName'>Full Name: {student.fullName} </h4>
       <h4 className='fullName'>Email: {student.email} </h4>
       <h4 className='fullName'>Phone Number: {student.number} </h4>
       <h4 className='fullName'>Class: {student.class} </h4>
       {/* <h4 className='fullName'>Id: {student.id} </h4> */}

       <div className='btnsConatiner'>

       <button className='editBtn' type='button'>Edit</button>
       <button className='dltBtn' type='button'>Delete</button>

       </div>

</li>
))

        }

</ul>
        
    </div>
  )
}

export default Students